import SectionHeading from './SectionHeading';
import { safetyTips } from '@/mocks/home';

export default function Safety() {
  return (
    <section id="safety" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Safety First"
          title="安全与防骗提示"
          desc="访问类问题多，冒充官方的骗局也不少。下面几条是经常出现的套路，记住它们能帮你避开绝大多数风险。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {safetyTips.map((t, i) => (
            <article
              key={t.title}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={i % 2 === 0 ? 'ri-shield-check-line text-xl' : 'ri-user-forbid-line text-xl'}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950">{t.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}